import React from "react";
import { Box, Flex, IconOnePassRibbon, Text } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PersonalisedOffer = function PersonalisedOffer() {
  return ___EmotionJSX(Flex, {
    alignItems: "center"
  }, ___EmotionJSX(Box, {
    flex: "1 1 auto",
    mr: 5
  }, ___EmotionJSX(IconOnePassRibbon, {
    width: "42px",
    height: "auto"
  })), ___EmotionJSX(Box, {
    flex: "1 1 auto",
    width: "100%"
  }, ___EmotionJSX(Text, {
    fontSize: "base",
    m: 0,
    fontWeight: "medium"
  }, "Personalised offers and rewards from", " ", ___EmotionJSX("strong", null, "Kmart, Target and Bunnings Warehouse"))));
};